module.exports.title = '${keyword}'
module.exports.description = '${question}'
module.exports.image = '${image}'
module.exports.heading = 'Book mentions in this thread'